import React from 'react';
import CalculationFormatter from '../../../../components/CalculationFormatter';
import PrepaidFormatter from '../../../../components/PrepaidFormatter';
import TransactionFormatter from '../../../../components/TransactionFormatter';

export const transactionFormatter = cell => <TransactionFormatter secret={cell} />;

export const calculationFormatter = cell => <CalculationFormatter id={cell} />;

export const prepaidFormatter = cell => <PrepaidFormatter isPrepaid={cell} />;

export default transactionFormatter;
